(function () {
    'use strict';
    // Directives used to organize our sidebar

    angular.module('GorillaBoy.directives')
    .directive('search', ['QuerySearchManager', 'SearchCommons', 'ClientMetricsService', 'MessageManager', 'MessageProvider', 'FeatureManagerService', 'Features', '$log',
      function (QuerySearchManager, SearchCommons, ClientMetricsService, MessageManager, MessageProvider, FeatureManagerService, Features, $log) {

        return {
            templateUrl: './search/search.html',
            scope: true,
            link: function ($scope, element, attrs) {

                $scope.isSearchV2Enabled = FeatureManagerService.isFeatureEnabled(Features.UI.SEARCH_V2);

                $scope.search = function () {

                    if (!$scope.searchInfo.query) {
                        return;
                    }
                    $log.info("Sending search request: " + $scope.searchInfo.query);

                    var query = QuerySearchManager.toNormalQuery($scope.searchInfo.query),
                        eventName  = "SEARCH_V2_FROM_DIRECTIVE_EVENT",
                        keywordsMap = QuerySearchManager.parseNormalizedQueryToKeywordsMap(query),
                        KEYWORDS = QuerySearchManager.CONSTANTS.KEYWORDS,
                        keywordsOptionsValue = {};

                    if (!$scope.isSearchV2Enabled) {
                        query = $scope.searchInfo.query;
                        eventName = "SEARCH_FROM_DIRECTIVE_EVENT";
                        keywordsMap = $scope.searchInfo.query;
                    }

                    ClientMetricsService.addLogsToSession({
                        event: eventName,
                        metadata: keywordsMap
                    });

                    if (keywordsMap[KEYWORDS.LOCATION] &&
                        keywordsMap[KEYWORDS.LOCATION] == SearchCommons.SEARCH_FIXED_OPTIONS.LOCATIONS.CURRENT_FOLDER) {

                          keywordsOptionsValue[KEYWORDS.LOCATION] = $scope.searchInfo.currentFolderId;

                          if(!keywordsOptionsValue[KEYWORDS.LOCATION]) {
                              MessageManager.addErrorMessage(MessageProvider.searchCurrentFolderInvalidOption);
                              return;
                          }
                    }

                    $scope.setSearchUrl(query, keywordsOptionsValue);
                };

                $scope.focusOrSearch = function() {

                    window.setTimeout(function(){
                        angular.element(".search-text").focus();
                    }, 500);

                    $scope.search();
                };

            }
        };
    }]);
}());
